export default ({ request }) => ({
  sysUserDetailApi(data = {}) {
    return request({
      url: '/sys/user/detail',
      method: 'post',
      data,
    })
  },
})
